var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Component, Prop, Ref, Mixins, Watch } from 'vue-property-decorator';
import { Form, Input, FormItem, Button, Select } from 'element-ui';
import { ReCaptchaVerificationMixin } from 'library-components/mixins/reCaptchaVerificationMixin';
import { CLOSE } from 'library-components/apis/passport/error';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import { Toast } from 'patsnap-biz';
import _ from 'lodash';
import { formFieldConfig } from 'library-components/config/formField';
import { getVerifyCodeAccountValue, getVerifyCodeCountDownTime, setVerifyCodeAccountValue, setVerifyCodeCountDownTime } from 'library-components/services/localStorage';
import { E_EMAIL_VERIFYCODE_PURPOSE } from 'library-components/apis/public/public.type';
import { postEmailVerifyCodeApi, postPublicForget } from 'library-components/apis/public/public';
import { getPublicKeyApi, postMobileVerifyCodeApi } from 'library-components/apis/login/login';
import { withLoading } from 'library-components/utils/task';
import { E_MobileVerifyCodePurpose } from 'library-components/apis/passport/types';
import { emailRe } from 'library-components/utils/regex';
import JSEncrypt from 'jsencrypt';
export function makeFormSendVerifyCode() {
    return {
        account: '',
        verify_code: '',
    };
}
/**
 * 发送验证码账号类型
 */
export var E_SEND_VERIFYCODE_ACCOUNT_TYPE;
(function (E_SEND_VERIFYCODE_ACCOUNT_TYPE) {
    E_SEND_VERIFYCODE_ACCOUNT_TYPE["EMAIL"] = "EMAIL";
    E_SEND_VERIFYCODE_ACCOUNT_TYPE["MOBILE_NUMBER"] = "MOBILE_NUMBER";
    E_SEND_VERIFYCODE_ACCOUNT_TYPE["ALL"] = "ALL";
})(E_SEND_VERIFYCODE_ACCOUNT_TYPE || (E_SEND_VERIFYCODE_ACCOUNT_TYPE = {}));
/**
 * 获取验证码存储名称
 * @param accountType 账号类型
 * @param emailPurpose 邮箱验证码用途
 * @param mobileNumberPurpose 手机验证码用途
 * @returns 存储名称
 * @description
 * 该函数用于生成验证码存储的唯一标识名称，主要用于：
 * 1. 验证码倒计时存储
 * 2. 验证码账号值存储
 * 3. 区分不同场景下的验证码（如登录、注册、找回密码等）
 *
 * @example
 * // 邮箱验证码场景
 * const emailStorageName = getVerifyCodeStorageName(
 *   E_SEND_VERIFYCODE_ACCOUNT_TYPE.EMAIL,
 *   E_EMAIL_VERIFYCODE_PURPOSE.SSO_USER_PROFILE
 * )
 *
 * // 手机验证码场景
 * const mobileStorageName = getVerifyCodeStorageName(
 *   E_SEND_VERIFYCODE_ACCOUNT_TYPE.MOBILE_NUMBER,
 *   E_EMAIL_VERIFYCODE_PURPOSE.SSO_USER_PROFILE,
 *   E_MobileVerifyCodePurpose.SSO_USER_PROFILE
 * )
 *
 * // 混合场景（ALL）
 * const allStorageName = getVerifyCodeStorageName(
 *   E_SEND_VERIFYCODE_ACCOUNT_TYPE.ALL,
 *   E_EMAIL_VERIFYCODE_PURPOSE.SSO_USER_PROFILE,
 *   E_MobileVerifyCodePurpose.SSO_USER_PROFILE
 * )
 *
 * @note
 * 1. 当 accountType 为 EMAIL 时，返回 emailPurpose
 * 2. 当 accountType 为 MOBILE_NUMBER 时，返回 mobileNumberPurpose
 * 3. 当 accountType 为 ALL 时，返回 emailPurpose + '_ALL'
 * 4. 对于 ALL 类型，添加 '_ALL' 后缀是为了避免与纯邮箱场景的存储名冲突
 */
export function getVerifyCodeStorageName(accountType, emailPurpose, mobileNumberPurpose) {
    // email purpose 和 mobile purpose 可能一样，加上字符串区分
    if (accountType === E_SEND_VERIFYCODE_ACCOUNT_TYPE.EMAIL) {
        return emailPurpose;
    }
    if (accountType === E_SEND_VERIFYCODE_ACCOUNT_TYPE.MOBILE_NUMBER) {
        return mobileNumberPurpose;
    }
    // accountType 如果是E_SEND_VERIFYCODE_ACCOUNT_TYPE.ALL 只要保证唯一就行了, 不需要区分手机号邮箱
    return emailPurpose + '_ALL';
}
export function sendVerifyCodeConfig() {
    return {
        /**
         * 账号类型
         */
        accountType: E_SEND_VERIFYCODE_ACCOUNT_TYPE.MOBILE_NUMBER,
        /**
         * 发送验证码purpose
         */
        emailPurpose: E_EMAIL_VERIFYCODE_PURPOSE.SSO_USER_PROFILE,
        /**
         * 发送验证码purpose
         */
        mobileNumberPurpose: E_MobileVerifyCodePurpose.SSO_USER_PROFILE,
        /**
         * 表单校验规则
         */
        rules: {},
        /**
         * 按钮禁用
         */
        sendVerifyCodeDisabled: false,
        accountLabel: '',
        verifyCodeLabel: null,
        canChoiceDomains: false,
        domains: [],
        accountPlaceholder: '',
        verifyCodePlaceholder: '',
    };
}
let SendVerifyCodeImpl = class SendVerifyCodeImpl extends Mixins(ReCaptchaVerificationMixin) {
    value;
    config;
    sendVerifyCodeDisabled;
    formRef;
    verifyCodeRef;
    reset() {
        this.formRef.resetFields();
    }
    loading = false;
    formFieldConfig = formFieldConfig;
    get Rules() {
        return this.config?.rules || {};
    }
    get verifyCodeLabel() {
        return _.isNil(this.config.verifyCodeLabel) ? this.$t('passport.register.verifyCode') : this.config.verifyCodeLabel;
    }
    domains = '';
    accountValue = '';
    get AccountMaxLength() {
        if (this.config.canChoiceDomains) {
            return formFieldConfig.email.max - this.domains.length;
        }
        return formFieldConfig.email.max;
    }
    OnAccountValueChange(value) {
        if (this.config.canChoiceDomains) {
            this.value.account = value + this.domains;
            return;
        }
        this.value.account = value;
    }
    OnDomainsChange(value) {
        if (this.config.canChoiceDomains) {
            this.value.account = this.accountValue + value;
            return;
        }
        this.value.account = this.accountValue;
    }
    OnAccountChange(value) {
        // 如果是由 accountValue 或 domains 变化触发的，则不处理
        if (this._isInternalChange) {
            this._isInternalChange = false;
            return;
        }
        this._isInternalChange = true;
        if (this.config.canChoiceDomains) {
            // 如果包含域名，则去除域名部分
            const domainIndex = this.config.domains.findIndex(domain => value.endsWith(domain));
            if (domainIndex !== -1) {
                this.accountValue = value.slice(0, -this.config.domains[domainIndex].length);
            }
            else {
                this.accountValue = value;
            }
        }
        else {
            this.accountValue = value;
        }
    }
    // 用于标记是否是内部变化触发的监听
    _isInternalChange = false;
    /**
     * 当前用户录入的账号类型 邮箱或手机号
     */
    get CurrentAccountType() {
        const { account } = this.value;
        if (this.config.accountType === E_SEND_VERIFYCODE_ACCOUNT_TYPE.ALL) {
            if (emailRe.test(account)) {
                return E_SEND_VERIFYCODE_ACCOUNT_TYPE.EMAIL;
            }
            if (/\d/.test(account) && account.length === 11) {
                return E_SEND_VERIFYCODE_ACCOUNT_TYPE.MOBILE_NUMBER;
            }
        }
        return this.config.accountType;
    }
    onAccountKeyupEnter() {
        this.onSendVerifyCode();
    }
    async onSendVerifyCode() {
        if (this.CanSendVerifyCode) {
            if (this.loading)
                return;
            this.loading = true;
            const resGeetestValidate = await this.geetestValidate();
            if (resGeetestValidate === CLOSE) {
                this.loading = false;
                return;
            }
            await withLoading(this, this.sendVerifyCode(resGeetestValidate));
        }
    }
    get resetPwdUrl() {
        return `${this.commonService.AccountHost}/public/${window.location.search}#/resetPassword`;
    }
    async sendVerifyCode(resGeetestValidate) {
        try {
            const { emailPurpose, mobileNumberPurpose } = this.config;
            const { account } = this.value;
            if (this.CurrentAccountType === E_SEND_VERIFYCODE_ACCOUNT_TYPE.EMAIL) {
                if (emailPurpose === E_EMAIL_VERIFYCODE_PURPOSE.PASSWORD_FORGOT) {
                    await postPublicForget({ email: account, forget_uri: this.resetPwdUrl });
                }
                else {
                    await postEmailVerifyCodeApi({ email: this.value.account, purpose: emailPurpose, lang: this.$i18n.locale }, resGeetestValidate);
                }
            }
            if (this.CurrentAccountType === E_SEND_VERIFYCODE_ACCOUNT_TYPE.MOBILE_NUMBER) {
                const publicKey = await getPublicKeyApi();
                const encrypt = new JSEncrypt({});
                encrypt.setPublicKey(publicKey);
                const encryptMobileNumber = encrypt.encrypt(account);
                await postMobileVerifyCodeApi({
                    mobile_number: encryptMobileNumber,
                    country_code: '+86',
                    purpose: mobileNumberPurpose,
                    lang: this.$i18n.locale,
                }, resGeetestValidate);
            }
            Toast({
                message: this.$t('passport.verifyCodeSendSuccess'),
                type: 'success',
                duration: 3000,
            });
            this.countDownStart();
            this.verifyCodeRef.focus();
        }
        catch (e) {
            let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
            const status = _.get(e, 'response.status');
            if (status === 500) {
                // 服务器错误直接-1
                // passport服务错误中也有 `number_error_code`
                errorCode = -1;
            }
            errorCode = errorCode === 30101 ? 30101.2 : errorCode;
            const { msg } = getAlertDataByCode({
                code: errorCode,
                lang: this.$i18n.locale,
            });
            if (errorCode) {
                Toast({
                    message: msg,
                    type: 'error',
                    duration: 3000,
                    showClose: true,
                });
            }
        }
    }
    /**
     * account、验证码倒计时缓存name
     */
    get VerifyCodeStorageName() {
        return getVerifyCodeStorageName(this.config.accountType, this.config.emailPurpose, this.config.mobileNumberPurpose);
    }
    /**
     * 倒计时开始执行
     */
    countDownStart() {
        const { account } = this.value;
        this.countDownInterValFun();
        setVerifyCodeCountDownTime(this.VerifyCodeStorageName);
        setVerifyCodeAccountValue(account, this.VerifyCodeStorageName);
    }
    verificationCodeCountdown = 60;
    get CanSendVerifyCode() {
        return !this.config.sendVerifyCodeDisabled && this.verificationCodeCountdown === 60 && !this.loading;
    }
    sendVerifyCodeBtnText = this.$t('passport.send_code');
    get SendVerifyCodeBtnText() {
        return this.verificationCodeCountdown === 60 ? this.sendVerifyCodeBtnText : `${this.verificationCodeCountdown}s`;
    }
    verificationCodeCountdownInterval = null;
    countDownInterValFun() {
        this.verificationCodeCountdownInterval = setInterval(() => {
            if (this.verificationCodeCountdown === 0) {
                clearInterval(this.verificationCodeCountdownInterval);
                this.verificationCodeCountdown = 60;
                this.sendVerifyCodeBtnText = this.$t('passport.personalInformation.resend');
                return;
            }
            this.verificationCodeCountdown--;
        }, 1000);
    }
    async created() {
        if (this.config.canChoiceDomains) {
            this.domains = this.config.domains[0] || '';
        }
        this.accountValue = this.value.account || '';
        const countDownTime = getVerifyCodeCountDownTime(this.VerifyCodeStorageName);
        const nowTime = new Date().getTime();
        if (countDownTime) {
            const countDownNumber = 60 - parseInt(((nowTime - countDownTime) / 1000).toString());
            if (countDownNumber <= 0)
                return;
            // 倒计时中需要缓存中的账号
            this.accountValue = getVerifyCodeAccountValue(this.VerifyCodeStorageName) || '';
            this.verificationCodeCountdown = countDownNumber;
            this.countDownInterValFun();
        }
    }
};
__decorate([
    Prop({
        type: Object,
        default() {
            return makeFormSendVerifyCode();
        },
    }),
    __metadata("design:type", typeof (_a = typeof T_FormSendVerifyCode !== "undefined" && T_FormSendVerifyCode) === "function" ? _a : Object)
], SendVerifyCodeImpl.prototype, "value", void 0);
__decorate([
    Prop({
        type: Object,
        default() {
            return sendVerifyCodeConfig();
        },
    }),
    __metadata("design:type", typeof (_b = typeof T_SendVerifyCodeConfig !== "undefined" && T_SendVerifyCodeConfig) === "function" ? _b : Object)
], SendVerifyCodeImpl.prototype, "config", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], SendVerifyCodeImpl.prototype, "sendVerifyCodeDisabled", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_c = typeof Form !== "undefined" && Form) === "function" ? _c : Object)
], SendVerifyCodeImpl.prototype, "formRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_d = typeof Input !== "undefined" && Input) === "function" ? _d : Object)
], SendVerifyCodeImpl.prototype, "verifyCodeRef", void 0);
__decorate([
    Watch('accountValue'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SendVerifyCodeImpl.prototype, "OnAccountValueChange", null);
__decorate([
    Watch('domains'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SendVerifyCodeImpl.prototype, "OnDomainsChange", null);
__decorate([
    Watch('value.account'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SendVerifyCodeImpl.prototype, "OnAccountChange", null);
SendVerifyCodeImpl = __decorate([
    Component({
        name: 'SendVerifyCode',
        components: {
            'el-form': Form,
            'el-form-item': FormItem,
            'el-input': Input,
            'el-button': Button,
            'el-select': Select,
        },
    })
], SendVerifyCodeImpl);
export { SendVerifyCodeImpl };
